export const Roles: Record<string, number> = {
    'employee': 1,
    'owner': 2,
    'superadmin': 3,
};